module.exports = __webpack_public_path__ + "img/icicle-george-v-store-opening-08.d9427625.jpg";